import { PlusIcon } from "@heroicons/react/24/outline";
import { RIGHT_BUTTON } from "@whyuz/data";
import { Button, ButtonProps, Tooltip } from "flowbite-react";

export interface PageAddEntityButtonProps extends ButtonProps {
  text: string;
  showText?: boolean;
  onAddNewEntity: () => void;
}

export const PageAddEntityButton = ({
  text,
  showText = true,
  onAddNewEntity,
  disabled,
  ...props
}: PageAddEntityButtonProps) => {
  return (
    <Tooltip content={text} placement="bottom" className={showText ? "hidden" : undefined}>
      <Button
        size="sm"
        color="primary"
        className={`px-0 ${showText ? "sm:px-0.5" : ""}`}
        onPointerDown={(e: React.PointerEvent) => {
          if (!disabled && e.button !== RIGHT_BUTTON) {
            onAddNewEntity();
          }
        }}
        disabled={disabled}
        {...props}>
        <PlusIcon className={`h-4 w-4 stroke-2 self-center`} />
        {showText && <span className="hidden sm:block ml-2">{text}</span>}
      </Button>
    </Tooltip>
  );
};
